import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Select} from "antd"
import {BATCH_STATUS} from "../../helper/batchStatus"

const {Option} = Select

class FilterStatus extends Component {
    _handleChangeStatus = (value) => {
        const {onChangeStatus} = this.props

        onChangeStatus('status', value)
    }

    render() {
        const {filters, statistic = {}} = this.props

        return (
            <div className='FilterStatus mr-4'>
                <label className="mr-2 font-weight-bold">Trạng thái:</label>
                <Select defaultValue={filters.status} name="status" style={{width: 180}}
                        onChange={this._handleChangeStatus}>
                    {
                        BATCH_STATUS.map((item, index) =>
                            <Option key={index} value={item.value}>
                                {item.name}
                                {
                                    (!!item.value && Object.keys(statistic).length > 0 && (!!statistic[item.value] || statistic[item.value] === 0)) &&
                                    <strong className="ml-1">({statistic.hasOwnProperty(item.value) && statistic[item.value]})</strong>
                                }
                            </Option>
                        )
                    }
                </Select>
            </div>
        )
    }
}

FilterStatus.propTypes = {
    filters: PropTypes.object.isRequired,
    statistic: PropTypes.object.isRequired,
    onChangeStatus: PropTypes.func.isRequired
}

export default FilterStatus